function ProcessList(num) {
    var arr = [];
    var processing = 0;
  
    function processed() {
		processing--;
		process();
    }
  
    function process() {
		var processItems = num - processing;
		if (processItems > arr.length) {
			processItems = arr.length;
		}
  
		for (var i = 0; i < processItems; i++) {
			var action = arr[0].action;
			var item = arr[0].item;
			action(processed, item);
			processing++;
			arr.splice(0, 1);
		}
    }
  
    return {
        add: function(action, item) {
            var size = arr.push({ action: action, item: item });
            var index = size - 1;
            var added = arr[index];
            process();
    
            return {
				remove: function() {
					var inx = arr.indexOf(added);
					if (inx > -1) {
						arr.splice(inx, 1);
					}
				}
            };
        }
    };
}

export default ProcessList


// WEBPACK FOOTER //
// ./src/SPRINTA/v2/helpers/ProcessList.js